function importFormat(fileName, allowCsv = true) {
  const extension = String(fileName || "").split(".").pop().toLowerCase();
  if (extension === "json" || (allowCsv && extension === "csv")) return extension;
  throw new Error(allowCsv ? "Bitte eine JSON- oder CSV-Datei auswählen." : "Bitte eine JSON-Datei auswählen.");
}

function importRequest(content, format, decisions = {}) {
  return {
    content, format,
    conflictActions: Object.entries(decisions)
      .filter(([, action]) => action === "update" || action === "skip")
      .map(([row, action]) => ({ row: Number(row), action }))
      .sort((a, b) => a.row - b.row),
  };
}

function canApplyPreview(preview, reviewedRevision, revision, busy) {
  return Boolean(!busy && reviewedRevision === revision && preview?.canApply && preview.previewToken
    && !(preview.errors || []).length && (preview.rows || []).every(row => !(row.errors || []).length));
}

module.exports = { importFormat, importRequest, canApplyPreview };
